<div class="page-title-area">
    <img src="assets/images/impetus_banner_new.jpeg" alt="Page Background" class="page-bg" style="width: 100%; height: 100%;">
    <!-- <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button> -->
    <div class="container" style="text-align: center;">
        <div class="section-title program-title" >
            <h2 style="color: #fff !important; font-weight: 500; text-transform: none;">iMpetus</h2>
            <h4 style="color: #fff !important; font-weight: 200; opacity: 1;">Power your startup with MacBooks and affordable IT solutions from Superior Digital.</h4>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <section class="features-section">
        <div class="container">
            <h2>Exclusively crafted for select startups across India.</h2>
            <br>
            <br>
            <div class="features-container">
                <div class="feature-card">
                    <div class="feature-image">
                        <img src="assets/images/itsolution.jpeg" alt="IT Solutions">
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Smart IT Solutions for Modern Businesses</h3>
                        <p>Empower your organisation with scalable Apple-based solutions tailored for enterprise efficiency and growth.</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <img src="assets/images/expert_assistance.jpeg" alt="CPU">
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Always-On Expert Assistance</h3>
                        <p>Get priority access to expert support that keeps your Apple ecosystem running smoothly, every step of the way</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <img src="assets/images/training_program.jpeg" alt="Compatibility">
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Training & Enablement</h3>
                        <p>Up-skill your teams with hands-on Apple training designed to boost productivity, creativity, and confidence.</p>
                    </div>
                </div>

                <div class="feature-card">
                    <div class="feature-image">
                        <img src="assets/images/flexible.jpeg" alt="Display">
                    </div>
                    <div class="feature-content" style="text-align: left;">
                        <h3>Flexible Ownership Options</h3>
                        <p>Choose smart leasing and financing plans that make it easy to equip your teams with the latest Apple technology</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>



<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>